<template>
  <Modal
    v-model="visible"
    width="900"
    title="批量失败修改"
    class-name="vertical-center-modal"
    :mask-closable="false"
    @on-visible-change="stateChange"
  >
    <el-table ref="table" stripe border :max-height="720" :columns="columns" :data="data">
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :sortable="col.sortable"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :formatter="col.format"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'copyPlan'">
            <span v-if="scope.row.length"
              >{{ scope.row.copyPlan.join('，') }} 等 <strong style="color: red">{{ scope.row.length }}</strong> 条计划可批量修改
            </span>
            <br v-if="scope.row.copyPlan.length && scope.row.failIds" />
            <span v-if="scope.row.failIds.length"
              >{{ scope.row.failIds.join('，') }} 等
              <strong style="color: red">{{ scope.row.failLength }}</strong> 条计划未满足修改条件，不可修改</span
            >
          </div>
          <div v-else-if="col.key === 'control'">
            <Button
              v-if="[10, 16, 32, 45, -40].includes(scope.row.mediaId) && scope.row.copyPlan.length"
              type="primary"
              @click="toBatchEdit(scope.row)"
              >去修改</Button
            >
            <span v-else>暂不支持</span>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </Modal>
</template>
<script>
import Cookies from 'js-cookie'
import { setSession } from '@/common/js/api'
import { setLocalInfo, setStoreName, camelcase } from '@/common/js/utils'
export default {
  name: 'batchEdit',
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getOpenUrl(media) {
      if (media === 10) return '/edit/local'
      else if (media === 16) return '/edit/tencent'
      else if (media === 32) return '/edit/kuaishou'
      else if (media === -40) return '/edit/toutiaov2'
      else return ''
    },
    toBatchEdit(row) {
      const { mediaId, planInfos } = row
      console.log('rowrowrowrowrowrow output: ', row)
      const account = Cookies.get('ch_user_name')
      const id = Cookies.get('ch_op_id')
      const openUrl = this.getOpenUrl(mediaId)
      const storeName = setStoreName(mediaId)

      setSession(
        'taskIds',
        planInfos.map((ret) => ret.taskId)
      )
      setSession('taskRows', planInfos)
      if (mediaId === -40) {
        window.open(openUrl, '_blank')
        return
      }
      setLocalInfo(id, account, String(mediaId))
      this.$store.commit(`${camelcase(storeName)}/setMedia`, mediaId)
      this.$store.commit(`${camelcase(storeName)}/setOpId`, id)
      this.$store.commit(`${camelcase(storeName)}/setAdmin`, account)
      if (row.mediaName === '巨量引擎2.0') window.open('/edit/toutiao', '_blank')
      else if (row.mediaName === '腾讯ADA') window.open('/edit/tencentada', '_blank')
      else window.open(openUrl, '_blank')
    },
    stateChange(val) {
      this.$emit('on-visible-change', val)
    }
  }
}
</script>
